export function analyticsHealth(data) {
  const accounts = (data?.networks || []).flatMap((network) => network.accounts || []);
  const needsAccess = accounts.filter((account) => account.status !== 'ready');
  const savedTimes = accounts.filter((account) => account.stale).map((account) => account.lastSuccessfulAt).filter(Boolean).sort();
  return {
    stale: Boolean(data?.stale || savedTimes.length),
    lastSuccessfulAt: savedTimes[0] || null,
    issue: needsAccess.length ? `${needsAccess.length} connected profile${needsAccess.length === 1 ? '' : 's'} need attention. Live posts, previews and metrics may be unavailable.` : ''
  };
}
